<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
    <p style="color: white">Please Wait...While Fetching Admins</p>
</ngx-spinner>

<div class="header_second">
    <div class="Dashboard_head ">Event Sub-Admins/Volunteers

        <button mat-raised-button color="primary" style="font-size: 14px;
                    margin-right: 15px;" (click)="AddEventUser()"><mat-icon>add</mat-icon>Add</button>
    </div>
</div>

<div class="mat-elevation-z8" style="margin: 0.5rem;">
    <mat-form-field appearance="outline" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" placeholder="Search" #input>
    </mat-form-field>
    <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" matSort>

            <ng-container matColumnDef="srNo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Sr No. </th>
                <td mat-cell *matCellDef="let element">{{element.srNo}}</td>
            </ng-container>

            <!-- <ng-container matColumnDef="event_image">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Image</th>
                <td mat-cell *matCellDef="let element">
                    <img src="{{element.event_image}}" style="width: 70px;height: 70px;">
                </td>
            </ng-container>

            <ng-container matColumnDef="event_logo">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Logo</th>
                <td mat-cell *matCellDef="let element">
                    <img src="{{element.event_logo}}" style="width: 70px;height: 70px;">
                </td>
            </ng-container> -->

            <ng-container matColumnDef="event_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Event Name</th>
                <td mat-cell *matCellDef="let element">{{element.event_name}}</td>
            </ng-container>

            <ng-container matColumnDef="mobile">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Mobile</th>
                <td mat-cell *matCellDef="let element">{{element.mobile}}</td>
            </ng-container>

            <ng-container matColumnDef="role">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Role </th>
                <td mat-cell *matCellDef="let element">{{element.role}}</td>
            </ng-container>

            <ng-container matColumnDef="user_name">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Username</th>
                <td mat-cell *matCellDef="let element">{{element.user_name}}</td>
            </ng-container>

            <ng-container matColumnDef="user_pwd">
                <th mat-header-cell *matHeaderCellDef mat-sort-header> Password </th>
                <td mat-cell *matCellDef="let element">{{element.user_pwd}}</td>
            </ng-container>

            <!-- <ng-container matColumnDef="from_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>From Date</th>
                <td mat-cell *matCellDef="let element"> {{element.from_date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="to_date">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>To Date</th>
                <td mat-cell *matCellDef="let element"> {{element.to_date | date:'dd/MM/yyyy'}} </td>
            </ng-container>

            <ng-container matColumnDef="from_time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>From Time</th>
                <td mat-cell *matCellDef="let element"> {{element.from_time}} </td>
            </ng-container>

            <ng-container matColumnDef="to_time">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>To Time</th>
                <td mat-cell *matCellDef="let element"> {{element.to_time}} </td>
            </ng-container> -->

            <ng-container matColumnDef="action" stickyEnd justify="end">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Action</th>
                <td mat-cell *matCellDef="let element">
                    <button *ngIf="element.role != 'admin'" mat-raised-button color="warn" matTooltip="Delete"
                        style="margin-left: 5px;" (click)="DeleteEvent(element.id)">
                        <mat-icon class=" m-0">delete</mat-icon>
                    </button>

                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>

    <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons
        aria-label="Select page of periodic elements">
    </mat-paginator>
</div>